import React from 'react';
// import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Card } from 'react-bootstrap';
import { PARENT_ROLE, EMPLOYEE_ROLE } from 'containers/User/constants.js';
import messages from '../messages.js';
import KeyUserType from './KeyUserType.jsx';
import useIsFoundation from '../../useIsFoundation.js';
import { MEMBERTYPE_STAFF } from '../../Groups/constants.js';

function KeyUsers() {
  const isFoundation = useIsFoundation();

  const userRoles = [
    isFoundation ? { id: MEMBERTYPE_STAFF, name: 'staff' } : { id: EMPLOYEE_ROLE, name: 'employee' },
  ];
  const keyUserTypes = [
    { id: 'managerroles', label: messages.schoolManagers, intro: messages.schoolManagersIntro, userRoles },
    !isFoundation && { id: 'administrativeroles', label: messages.adminEmployees, intro: messages.adminIntro, userRoles },
    !isFoundation && {
      id: 'leadauthors',
      label: messages.leadAuthors,
      intro: messages.leadIntro,
      settingsId: 'leadauthorsettings',
      userRoles: [...userRoles, { id: PARENT_ROLE, name: 'parent' }],
    },
  ].filter(Boolean);
  return (
    <Card>
      <Card.Body>
        <h2 className="card-title mb-4"><FormattedMessage {...messages.keyUsers} /></h2>
        {keyUserTypes.map((type) => <KeyUserType key={type.id} {...type} />)}
      </Card.Body>
    </Card>
  );
}

export default KeyUsers;
